import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BasicDialogButtonsEnum } from '../dialog.data';
import { IIcon } from '../../icon/icon.component';
import { I2gDialogService } from '../../../services/dialog/i2g-dialog.service';
import { ButtonStyle } from '../../../directives/button/button.directive';

@Component({
  selector: 'i2g-dialog-basic',
  templateUrl: './dialog-basic.component.html',
  styleUrls: ['./dialog-basic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogBasicComponent {
  @Input() icon: IIcon;
  @Input() title: string;
  @Input() body: string;
  @Input() primaryButtonText: string;
  @Input() primaryButtonStyle: ButtonStyle = 'emphasis';
  @Input() secondaryButtonText: string;
  @Input() disablePrimaryButton: boolean;
  @Input() disableSecondaryButton: boolean;

  constructor(private _dialogService: I2gDialogService) {}

  onPrimaryButtonClicked() {
    this._dialogService.closeDialog({
      buttonPressed: BasicDialogButtonsEnum.primary,
    });
  }

  onSecondaryButtonClicked() {
    this._dialogService.closeDialog({
      buttonPressed: BasicDialogButtonsEnum.secondary,
    });
  }
}
